const $ = window.jQuery;

export function scrollToElement(el) {
  const elementTop = $(el).offset().top;

  const preferredScrollTop =
    elementTop -
    window.innerHeight +
    el.offsetHeight +
    $(".wiz-footer").height() +
    15;

  if ($("html").scrollTop() < preferredScrollTop) {
    $("html").scrollTop(preferredScrollTop);
  }
}
